import { render, staticRenderFns } from "./SendFromBlockConso.vue?vue&type=template&id=4635f54c&scoped=true"
import script from "./SendFromBlockConso.vue?vue&type=script&lang=js"
export * from "./SendFromBlockConso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4635f54c",
  null
  
)

export default component.exports